import React from 'react';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';
import { Messages } from '~src/codegen/Localize';
import { GetServerWelcomeChannelInfoRequest } from '~src/home/requests/GetServerWelcomeChannelInfoRequest';
import { IUpdateServerWelcomeChannelInfoResult, UpdateServerWelcomeChannelInfoRequest } from '~src/home/requests/UpdateServerWelcomeChannelInfoRequest';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { coordinatorSubmitFailedHandler, coordinatorSubmitHandler } from '~src/settings/general-settings/components/common/GeneralToastHandlers';
import { CustomizationSettings, CustomizationSettingsOwnProps } from '~src/settings/welcomeChannelCustomization/components/CustomizationSettings';

export function CustomizationSettingsSubspace() {

  const [initialServerWelcomeChannelInfo, setInitialServerWelcomeChannelInfo] = React.useState(undefined);
  React.useEffect(() => {
    const fetch = async () => {
      const info = await WebHttpClient.sendRequest(new GetServerWelcomeChannelInfoRequest());
      setInitialServerWelcomeChannelInfo(info);
    };
    fetch();
    BrowserTitleService.setTitleWithTranslatedSpace({translatedSpaceName: Messages.serverSettings_customization()});
  }, [setInitialServerWelcomeChannelInfo]);

  const sendUpdateRequest = (defaultBannerEnabled: boolean, serverFooter: string): Promise<IUpdateServerWelcomeChannelInfoResult> => {
    return WebHttpClient.sendRequest(
      new UpdateServerWelcomeChannelInfoRequest({
        welcomeChannelEnabledForServer: defaultBannerEnabled,
        welcomeChannelServerFooter: serverFooter
      })
    );
  };

  const customizationSettingsProps: CustomizationSettingsOwnProps = {
    initialServerWelcomeChannelInfo,
    sendUpdateRequest
  };

  return (
    <div className={'tb-stylish-settings'} style={{flexGrow: 1}}>
      <SettingsCoordinator
        onSubmit={coordinatorSubmitHandler}
        onSubmitFailure={coordinatorSubmitFailedHandler}
        allowFullWidthSections={true}
      >
        <CustomizationSettings {...customizationSettingsProps} />
      </SettingsCoordinator>
    </div>
  );
}
